/**
 * F-erros-i18n (auditoria UX, item 3) — o servidor já devolve a mensagem no
 * idioma do usuário e, quando sabe, o CAMPO do formulário em `data.field`
 * (ex.: nº fiscal duplicado → "fiscalId"). Este helper lê isso de qualquer
 * erro do tRPC para a tela mostrar o texto ao lado do campo certo.
 */
export interface ErroDeCampo {
  field: string | null;
  message: string;
}

export function erroDeCampo(e: unknown): ErroDeCampo {
  const message =
    typeof e === "object" && e != null && "message" in e && typeof e.message === "string"
      ? e.message
      : String(e);
  const data =
    typeof e === "object" && e != null && "data" in e
      ? (e as { data?: { field?: unknown } | null }).data
      : null;
  const field = data && typeof data.field === "string" ? data.field : null;
  return { field, message };
}
